import { z } from 'zod'

const GuaranteeSchema = z.object(
  {
    id: z.number().nullable(),
    sequenceNumber: z.number().nonnegative(),
    amount: z.number().nonnegative(),
    nctsProfileId: z.number().nullable(),
    deleted: z.boolean().optional(),
  },
)
export type GuaranteeFormValues = z.infer<typeof GuaranteeSchema>

export function isGuaranteePresent(guarantee: GuaranteeFormValues): boolean {
  return guarantee.id != null || guarantee.nctsProfileId != null
}

export default GuaranteeSchema
